import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentType } from '../enums/general/environment.enum';
import { IUserAuth } from '../interfaces/user/user';

@Injectable()
export class UserInjectionInterceptor implements HttpInterceptor {
    private readonly regex = new RegExp(/\w*userid\b/gm, 'i');
    private readonly apis = [
        'apim-core-uat-zan.azure-api.net',
        'api-uat.lawyerly.co.za',
        'api-uat.lawforall.co.za'
    ];

    constructor() {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (
            environment.environmentType != EnvironmentType.Local ||
            this.apis.some(el => req.url.includes(el))
        ) {
            return next.handle(req);
        }

        return next.handle(req).pipe(
            map(event => {
                if (event instanceof HttpResponse) {
                    this.findKey(event.body);
                    return event;
                }
            })
        );
    }

    private findKey(obj: any) {
        if (obj) {
            Object.entries(obj).forEach(key => {
                if (typeof key[1] === 'object') {
                    this.findKey(key[1]);
                } else {
                    if (this.regex.test(key[0])) {
                        obj[`${key[0].substring(0, key[0].length - 2)}`] = {
                            userId: key[1],
                            displayName: 'Local Host',
                            profilePictureUri:
                                'http://localhost:4200/assets/images/error/anonymous.png' //TODO: Use relative paths
                        } as IUserAuth;
                    }
                }
            });
        }
    }
}
